<template>
  <v-layout>
    <v-data-table :headers="headers" :items="items" style="flex: 1 1 auto">
      <template v-slot:items="props">
        <tr>
          <td>{{ formatAliasName(props.item) }}</td>
          <td>
            <span v-if="props.item.IsDefault || !editMode">
              -
            </span>
            <template v-else>
              <v-btn color="primary" small @click="setDefaultAlias(props.item.Name)">Set as default</v-btn>
              <v-btn color="error" small @click="deleteAlias(props.item.Name)">Delete</v-btn>
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="addAliasModal" persistent max-width="500">
      <v-card>
        <v-card-title class="title">
          Add Alias
          <v-spacer />
          <v-btn icon @click.native="closeAddForm">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="addForm" v-model="addForm.valid">
          <v-card-text pa-2>
            <v-text-field label="Alias Name" v-model="addForm.values.aliasName" :rules="addForm.rules.aliasName">
            </v-text-field>
            <v-switch v-model="addForm.values.isDefault" label="Default Alias"></v-switch>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="submitAddForm" :disabled="!addForm.valid">Add</v-btn>
            <v-btn color="secondary" @click="closeAddForm">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  export default {
    props: {
      configName: {
        type: String,
        required: true,
      },
      columnConfiguration: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        addAliasModal: false,
        headers: [{
          text: 'Alias Name',
          align: 'left',
          value: 'Name',
          width: '60%',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'left',
          value: '',
          width: '40%',
          sortable: false,
        },
        ],
        addForm: {
          values: {
            aliasName: '',
            isDefault: false,
          },
          rules: {
            aliasName: [
              v => !!v || 'Alias name cannot be blank',
              v => this.columnConfiguration.NameAliases.findIndex(x => x.Name == v) < 0 ||
              'Alias name already exists',
            ],
          },
          valid: true,
        },
      }
    },
    computed: {
      items() {
        let items = (this.columnConfiguration && this.columnConfiguration.NameAliases) || []
        // place default alias on top
        items.sort((a, b) => {
          if (a.IsDefault) {
            return -1
          }
          if (b.IsDefault) {
            return 1
          }
          return a.Name <= b.Name ? -1 : 1
        })
        return items
      },
    },
    methods: {
      ...eddConfiguration.mapActions(['upsertColumnNameAlias', 'deleteColumnAlias']),
      formatAliasName(alias) {
        return alias.IsDefault ? `${alias.Name} (default)` : alias.Name
      },
      setDefaultAlias(aliasName) {
        this.upsertColumnNameAlias({
          configName: this.configName,
          columnId: this.columnConfiguration.Id,
          aliasName: aliasName,
          isDefault: true,
        })
      },
      deleteAlias(aliasName) {
        this.deleteColumnAlias({
          configName: this.configName,
          columnId: this.columnConfiguration.Id,
          aliasName: aliasName,
        })
      },
      openAddAlias() {
        this.addAliasModal = true
      },
      resetAddForm() {
        this.addForm.values = {
          aliasName: '',
          isDefault: false,
        }
        this.$refs.addForm.resetValidation()
      },
      submitAddForm() {
        this.upsertColumnNameAlias({
          configName: this.configName,
          columnId: this.columnConfiguration.Id,
          aliasName: this.addForm.values.aliasName,
          isDefault: this.addForm.values.isDefault,
        })
        this.closeAddForm()
      },
      closeAddForm() {
        this.addAliasModal = false
        this.resetAddForm()
      },
    },
  }
</script>